/* =====================================================================================
   TRUCKING RATES: THE ONLY PART YOU EDIT EACH QUARTER
   Everything between the two big lines is plain data. Do not change anything below the
   second big line. After you edit, click Save and test: Illinois, 1 pallet, should show
   its trucking fee; 2 pallets should show the "available at Checkout" message.
   These numbers are only the page estimate. Checkout charges live Estes freight minus $500.
   To refresh the numbers each quarter, ask Claude to re-quote Estes. It sends you the replacement block.
   ===================================================================================== */

var M4_RATES_UPDATED = 'October 15, 2026';   // change this when you change the numbers

/* 1) STATE RINGS. "add" is the extra trucking charge for the state, per pallet, on top of
      the $500 already built into the Delivery price. Each state appears in exactly one ring. */
var M4_BUILT_IN = 500;
var M4_RINGS = [
  { add: 0,   states: 'IA IN MN MO ND NE SD WI' },                         // total trucking $500
  { add: 100, states: 'AR IL KS KY MI OH TN' },                             // $600
  { add: 200, states: 'AL DE GA MD MS MT NC OK PA VA WV' },                 // $700
  { add: 300, states: 'CO ID NJ SC TX UT' },                                // $800
  { add: 400, states: 'AZ CA CT FL MA ME NH NV OR RI VT WA' },              // $900
  { add: 500, states: 'DC LA NM NY WY' }                                    // $1,000
];

/* 2) MULTI-PALLET STEPS. [from this many pallets, share of the 1-pallet trucking charge].
      Used only for the page estimate. Not connected to any Shopify discount. */
var M4_TIERS = [ [2, 0.97], [3, 0.82], [5, 0.70], [6, 0.65], [8, 0.60] ];

/* 3) WHAT SHOPPERS SEE AT 2+ PALLETS.  'hide' = Option A (numbers hidden).  'gray' = Option B. */
var M4_MULTI_MODE = 'hide';
var M4_TEXT_HIDE  = 'Trucking for 2+ pallets is available at Checkout.';
var M4_TEXT_GRAY  = 'See final amount at Checkout.';
var M4_TEXT_ONE   = 'See final amount at Checkout.';

/* =====================================================================================
   END OF THE PART YOU EDIT. NOTHING BELOW THIS LINE NEEDS CHANGING.
   ===================================================================================== */
(function () {
  var NAMES = {AL:'Alabama',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington, DC',FL:'Florida',GA:'Georgia',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};
  var ADD = {};   // state -> extra charge per pallet
  M4_RINGS.forEach(function (r) { r.states.split(' ').forEach(function (s) { if (s) ADD[s] = r.add; }); });

  function tier(q) {
    var f = 1;
    M4_TIERS.forEach(function (t) { if (q >= t[0]) f = t[1]; });
    return { f: f, D: Math.round(M4_BUILT_IN * (1 - f)) };
  }
  function estimate(base, q, st) {
    if (ADD[st] === undefined) return null;
    var t = tier(q), sh = Math.round(ADD[st] * t.f / 5) * 5, per = base - t.D + sh;
    return { per: per, total: per * q, shipPerPallet: sh, discountPerPallet: t.D };
  }
  window.M4TruckingEstimate = { estimate: estimate, tier: tier, ADD: ADD, NAMES: NAMES, updated: M4_RATES_UPDATED };

  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function init() {
    var root = document.getElementById('trucking-estimate');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var section = root.dataset.section, LBS = +root.dataset.lbs || 1909;
    var variants = {};
    try { JSON.parse(document.getElementById('trucking-variants').textContent).forEach(function (v) { variants[v.id] = v; }); } catch (e) { return; }
    var S = { open: false, st: '' };

    var opts = '<option value="">Ship to State</option>' + Object.keys(NAMES).sort(function (a, b) { return NAMES[a].localeCompare(NAMES[b]); })
      .map(function (s) { return '<option value="' + s + '">' + NAMES[s] + '</option>'; }).join('');
    root.innerHTML =
      '<button type="button" class="m4t-toggle" aria-expanded="false" aria-controls="m4t-body">Estimate Trucking Cost</button>' +
      '<div class="m4t-body" id="m4t-body" hidden>' +
        '<label class="m4t-sr" for="m4t-state">Ship to State</label>' +
        '<select id="m4t-state">' + opts + '</select>' +
        '<div class="m4t-result" aria-live="polite"></div>' +
        '<p class="m4t-fine m4t-tip">Buy 2+ Pallets &amp; Save on Shipping Cost (add items to cart to see savings)</p>' +
        '<div class="m4t-cap"><p class="m4t-fine m4t-q">Questions? <a href="tel:+16122347835">Call</a>/<a href="sms:+16122347835">text</a> us at 612.234.7835.</p></div>' +
      '</div>';
    var toggle = root.querySelector('.m4t-toggle'), body = root.querySelector('.m4t-body'),
        sel = root.querySelector('#m4t-state'), out = root.querySelector('.m4t-result'),
        tip = root.querySelector('.m4t-tip'), cap = root.querySelector('.m4t-cap');

    function variantId() {
      var f = document.querySelector('#product-form-' + section + ' input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return f ? +f.value : 0;
    }
    function qty() {
      var f = document.querySelector('#product-form-' + section + ' input[name="quantity"]') || document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      var n = f ? parseInt(f.value, 10) : 1; return n > 0 ? n : 1;
    }
    function breakdown(e, base, q, dim) {
      var nm = NAMES[S.st], sv = e.discountPerPallet * q, tr = e.shipPerPallet * q, d = dim ? ' m4t-dim' : '';
      return '<div class="m4t-brk">' +
        '<div class="m4t-row' + d + '"><span>' + 'Feed Cost' + '</span><span>' + money(base * q) + '</span></div>' +
        (sv ? '<div class="m4t-row' + d + '"><span>Multi-pallet discount</span><span>\u2212' + money(sv) + '</span></div>' : '') +
        '<div class="m4t-row' + d + '"><span>Trucking Cost (estimate)</span><span>' + (tr ? money(tr) : 'Included') + '</span></div>' +
        '<div class="m4t-row m4t-total' + d + '"><span>Estimated Total</span><span>' + money(e.total) + '</span></div>' +
        '<span class="m4t-fine' + d + '">' + money(e.per / LBS) + '/lb with trucking</span>' +
        (dim ? '' : '<span class="m4t-fine">' + M4_TEXT_ONE + '</span>') +
        '</div>';
    }
    function update() {
      var v = variants[variantId()], show = !!(v && v.delivered);
      root.hidden = !show; if (!show) return;
      toggle.setAttribute('aria-expanded', String(S.open)); body.hidden = !S.open;
      root.classList.toggle('m4t-open', S.open);
      var q = qty(), multi = q >= 2, hide = multi && M4_MULTI_MODE === 'hide';
      var e = S.st ? estimate(v.price / 100, q, S.st) : null;
      sel.hidden = hide;
      tip.hidden = multi;
      cap.hidden = !(multi || e);
      if (hide) { out.innerHTML = '<span class="m4t-lead">' + M4_TEXT_HIDE + '</span>'; return; }
      if (!e) { out.innerHTML = ''; return; }
      var base = v.price / 100;
      out.innerHTML = multi
        ? '<span class="m4t-lead">' + M4_TEXT_GRAY + '</span>' + breakdown(e, base, q, true)
        : breakdown(e, base, q, false);
    }
    toggle.addEventListener('click', function () { S.open = !S.open; update(); });
    sel.addEventListener('change', function () {
  S.st = sel.value;
  update();
  if (!S.st) return;
  try {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Trucking estimate state': S.st } })
    });
  } catch (e) {}
});
    document.addEventListener('variant:change', update);
    document.addEventListener('productInfo:loaded', update);
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') update(); });
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') update(); });
    document.addEventListener('click', function () { setTimeout(update, 50); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();